import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "display-3"
}
const _hoisted_4 = { class: "contact-box-wrapper" }
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "d-block font-weight-bold"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    action: _ctx.action,
    ref: "form"
  }, [
    _renderSlot(_ctx.$slots, "filter", {
      filter: _ctx.list.filter,
      locationChange: _ctx.locationChange,
      isLoading: _ctx.isLoading,
      hasPropertyError: _ctx.hasPropertyError,
      getErrorMessage: _ctx.getErrorMessage
    }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.boxTitle)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.boxTitle), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.listColClass)
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
                  [_vShow, _ctx.list.isLoading.value]
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (!_ctx.list.isLoading.value && !_ctx.list.visibleItems.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.noResultsLabel)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.noResultsLabel) + "…", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_TransitionGroup, {
            tag: "div",
            class: "row contact-list-animation-container",
            name: "fade"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.visibleItems.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.uid,
                  class: _normalizeClass(`arrange-item ${_ctx.itemColClass}`),
                  innerHTML: item.content
                }, null, 10, _hoisted_11))
              }), 128))
            ]),
            _: 1
          })
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.formColClass)
      }, [
        (_ctx.htmlResponse)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.htmlResponse
            }, null, 8, _hoisted_12))
          : _createCommentVNode("", true),
        (!_ctx.htmlResponse)
          ? _renderSlot(_ctx.$slots, "default", { key: 1 })
          : _createCommentVNode("", true),
        (!_ctx.htmlResponse)
          ? _renderSlot(_ctx.$slots, "fields", {
              key: 2,
              isLoading: _ctx.isLoading,
              send: _ctx.send,
              hasPropertyError: _ctx.hasPropertyError,
              getErrorMessage: _ctx.getErrorMessage
            })
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 8, _hoisted_1))
}